import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    buildingComplexId: String
  }
  static targets = ["filterToggleButton", "myReportsButton", "allReportsButton", "newReportButton"]
  static outlets = ["resident-report"]

  connect() {
    this.updateFilterButtonState(false)
  }

  toggleFilter() {
    if (this.hasResidentReportOutlet) {
      this.residentReportOutlet.toggleFilter()
    }
  }

  updateFilterButtonState(isVisible) {
    // Update filter button state based on visibility
    if (this.hasFilterToggleButtonTarget) {
      // The button state is managed by the CSS class
      // This method can be used for additional state management if needed
    }
  }

  updateFilterIcon(isActive) {
    // Update filter icon based on active state
    if (this.hasFilterToggleButtonTarget) {
      const icon = this.filterToggleButtonTarget.querySelector('i')
      if (icon) {
        icon.className = isActive ? 'bi bi-funnel-fill' : 'bi bi-funnel'
      }
    }
  }

  residentReportOutletConnected() {
    console.debug('[resident-report-breadcrumbs_controller] residentReportOutletConnected')
  }
}

